import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef, useEffect } from 'react';
// material
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setPageTitle, setPageSubtitle } from 'src/redux/slices/ui';
import { COMPANY_NAME } from '../constants';

// ----------------------------------------------------------------------

const Page = forwardRef(
  ({ children, title = '', subtitle = '', ...other }, ref) => {
    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(setPageTitle(title));
      dispatch(setPageSubtitle(subtitle));
    }, [dispatch, title]);

    return (
      <Box ref={ref} {...other} sx={{ height: '100%' }}>
        <Helmet>
          <title>{`${title} | ${COMPANY_NAME}`}</title>
        </Helmet>
        {children}
      </Box>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default Page;
